import React, { useRef } from "react";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { useTheme } from '../../contexts/ThemeContext';
import Footer from "./Footer";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const containerStyle = { width: "100%", height: "100%" };

// 🇧🇷 Centro do Brasil
const brazilCenter = { lat: -14.2350, lng: -51.9253 };
const brazilZoom = 6.1;

const MapContent = () => {
  const { theme } = useTheme();
  const mapRef = useRef(null);

  const handleMapLoad = (map) => {
    mapRef.current = map;
  };

  return (
    <div className="relative w-full h-[2000px] md:h-[1350px] overflow-hidden mt-12">
      {/* MAPA GOOGLE */}
      <div className="absolute inset-0 z-0">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={brazilCenter}
          zoom={brazilZoom}
          onLoad={handleMapLoad}
          options={{
            disableDefaultUI: true,
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            gestureHandling: "none",
            mapTypeId: "roadmap",
            styles: [
              { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#d5ead5" }] },
              { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#b5dcb5" }] },
              { featureType: "water", elementType: "geometry", stylers: [{ color: "#8fc8e3" }] },
              { featureType: "road", elementType: "geometry", stylers: [{ color: "#e8e8e8" }] },
              { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#333333" }] },
              { featureType: "all", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
            ],
          }}
        />
        <div className="absolute inset-0 z-[6] pointer-events-none">
          <div className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-[120px]">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-10 shadow-lg text-center">
              <p className="text-3xl sm:text-xl font-semibold pl-3 text-[#108AFF]">
                ATENDIMENTO EM TODO O BRASIL
              </p>
              <p className="text-sm text-gray-600 mt-4">
                Home Care com equipe especializada e atendimento qualificado em todo o território nacional
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CONTROLES E SOBREPOSIÇÕES */}
      <div className="absolute inset-0 z-[5] pointer-events-none bg-gradient-to-b from-[#f3f6f8] via-white/20 to-transparent h-[20%]"></div>

      <div className="absolute inset-0 z-10 flex flex-col justify-between items-center pointer-events-none">
        {/* CARD DE AJUDA */}
        <div className="w-full max-w-5xl bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-3 flex items-center justify-between pointer-events-auto mt-4 mx-4">
          <div className="pl-8">
            <p className="text text-gray-900">Precisa de Ajuda?</p>
            <p className="text-sm text-gray-400">Formulário • Contato</p>
            <p className="text-sm text-gray-400">08:00 • 18:00</p>
          </div>

          <div className="d-flex flex-row">
            <p className="hidden md:block text-sm text-gray-400 max-w-md px-2">
              Não consegue encontrar exatamente o que procura?
            </p>
            <p className="hidden md:block text-sm text-gray-400 max-w-md px-2">
              Entre em contato com os nossos atendentes treinados para te guiar
              na sua escolha para o melhor do seu tratamento.
            </p>
          </div>

          <a
            className="bg-black text-white font-semibold text-sm mr-8 px-6 py-3 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap pointer-events-auto"
            href={`https://wa.me/5511999999999?text=${encodeURIComponent(
              "Olá! Gostaria de falar com um especialista."
            )}`}
          >
            Entrar em contato
          </a>
        </div>

        {/* FOOTER */}
        <div className="w-full flex flex-col items-center mt-6 pointer-events-auto">
          <div className="w-full !mt-0">
            <Footer />
          </div>
        </div>
      </div>

      <div
        className="absolute inset-x-0 bottom-0 z-[5] pointer-events-none to-transparent h-[1600px]"
        style={{
          backgroundImage: `linear-gradient(to top, ${theme.gradientColor}, rgba(255, 255, 255, 0.3), transparent)`
        }}
      />
    </div>
  );
};

const MapLoader = ({ children }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: API_KEY
  });

  if (loadError) return <div className="text-red-600 text-center p-8">Erro ao carregar o mapa.</div>;
  if (!isLoaded) return <div className="text-gray-500 text-center p-8">Carregando Mapa...</div>;
  return <>{children}</>;
};

const MapAndCardsHomeCare = (props) => (
  <MapLoader>
    <MapContent {...props} />
  </MapLoader>
);

export default MapAndCardsHomeCare;
